import { operatorsService } from "@/apis/services"
import { IOperator, IPaginationMeta, IPaginationParamV2 } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IOperatorState {
  operators: IOperator[]
  currentOperator: IOperator | null
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchOperators: (params: IPaginationParamV2) => Promise<void>
}

const initialState = {
  operators: [],
  currentOperator: null,
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useOperatorsStore = create<IOperatorState>()(
  devtools(set => ({
    ...initialState,
    fetchOperators: async (params: IPaginationParamV2) => {
      set({ isLoading: true, error: null })
      try {
        const response = await operatorsService.getOperators(params)
        set({ operators: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occurred"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
